import React from 'react';
import { Box, Tooltip, IconButton, PopoverTrigger } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@fortawesome/pro-regular-svg-icons';

import { UnreadBadge } from './UnreadBadge';

interface IMessageButtonProps {
  totalUnreadCount: number;
  label?: string;
}

const MessagesButton = (props: IMessageButtonProps): React.ReactElement => {
  const { totalUnreadCount, label = 'View messages' } = props;

  return (
    <>
      <Tooltip hasArrow placement="top-end" label={label}>
        <Box position="relative">
          <PopoverTrigger>
            <IconButton
              id="message-inbox-button"
              aria-label={`${label} (${totalUnreadCount} unread)`}
              icon={<FontAwesomeIcon icon={faComments} />}
              variant="solid"
              size="lg"
              isRound
              height={'60px'}
              width={'60px'}
              fontSize="2xl"
            />
          </PopoverTrigger>

          <UnreadBadge count={totalUnreadCount} size="md" />
        </Box>
      </Tooltip>
    </>
  );
};

export { MessagesButton };
